module.exports = "/_next/static/videos/golf-2-531900edead3af3df56be72f0582a679.webm";